import './App.css';
import Portfolio from './components/Portfolio';

function App() {
  
  return (
    <div className="App overflow-hidden">
      <Portfolio/>
    </div>
  );
}

export default App;
